import useApiFetch from 'src/app/hooks/useApiFetch';
import DataWrapperChildrenParams from 'src/app/interfaces/dataWrapperChildrenParams';
import DataWrapperProps from 'src/app/interfaces/dataWrapperProps';
import {DataWrapperCallback} from 'src/app/interfaces/dataWrapperCallback';
import BaseFetchOptions from 'src/data/api/common/BaseFetchOptions';
import ApiResponseBody from 'src/data/api/responses/ApiResponseBody';
import {EmptyBody} from 'src/data/models/common/emptyBody';
import orderlineService from 'src/data/services/orderlineService';

type ResponseType = ApiResponseBody<EmptyBody>;

interface LinkOrderlinesDataWrapperChildrenParams extends DataWrapperChildrenParams<ResponseType> {
    linkOrderlines: (
        orderLineId: string,
        targetOrderLineId: string,
        callbacks?: DataWrapperCallback<ResponseType>
    ) => Promise<ResponseType>;
}

type LinkOrderlinesDataWrapperProps = DataWrapperProps<
    LinkOrderlinesDataWrapperChildrenParams,
    ResponseType
> &
    BaseFetchOptions;

export const useLinkOrderlinesDataWrapper = ({
    onError,
    onSuccess,
}: Omit<LinkOrderlinesDataWrapperProps, 'children'>) => {
    const [{loading, data, errors, resetData}, handleLinkOrderlines] = useApiFetch<ResponseType>();

    const linkOrderlines = (
        orderLineId: string,
        targetOrderLineId: string,
        callbacks?: DataWrapperCallback<ResponseType>
    ) => {
        return handleLinkOrderlines(
            orderlineService.linkOrderlines(orderLineId, targetOrderLineId),
            {
                useDefaultErrorHandler: true,
                defaultSuccessMessage: 'Orderlines linked',
                onFail: () => {
                    onError?.();
                    callbacks?.onFail?.();
                },
                onSuccess: (data) => {
                    onSuccess?.(data);
                    callbacks?.onSuccess?.(data);
                },
            }
        );
    };

    return {
        linkOrderlines,
        data,
        loading,
        errors,
        resetData,
    };
};

export const LinkOrderlinesDataWrapper = (props: LinkOrderlinesDataWrapperProps) => {
    const {children} = props;
    const hookData = useLinkOrderlinesDataWrapper(props);

    if (!children) return <></>;

    return <>{children(hookData)}</>;
};
